import {
    AnalyticsRequest,
    GroupBy,
    Metric,
    Sort,
} from '../../PanelTemplatesTheme/PanelTemplatesTheme';
import { Widget } from '@sprinklr/stories/widget/Widget';
import { WIDGET_LABEL_SIZE } from 'components/Widget/WidgetLabel/constants';
import ListeningDimensions from '@sprinklr/stories-services/AnalyticsService/ListeningDimensions';
import { DefaultWidgetPosition } from '../../PanelTemplatesTheme/constants';

export const HyperSpaceTreeMap: Widget = {
    type: 'hyperSpaceTreeMap',
    id: 'hyper-space-tree-map',
    name: 'Tree Map',
    useGlobalTimePeriod: true,
    useGlobalTranslate: true,
    translationLanguage: null,
    analyticsRequests: [
        // Note: All global variables like reportingEngine, report, filters, and projections
        // are injected via AnalyticsRequest.getRequests()
        new AnalyticsRequest({
            limit: 6,
            projections: [
                new Metric({
                    STORY_MESSAGE: { dimensionName: 'IMPACT', heading: 'Web_Impact' },
                }),
            ],
            groupBys: [
                new GroupBy({
                    LISTENING: { source: ListeningDimensions.topicName },
                    INBOUND_MESSAGE: { dimensionName: 'SN_TYPE' },
                    PLATFORM: { dimensionName: 'SN_TYPE' },
                    BENCHMARKING: { dimensionName: 'BENCHMARKING_SN_TYPE' },
                    PAID: { dimensionName: 'adCreativeType' },
                    ADVOCACY: { dimensionName: 'COMMUNITY_USER_ID' },
                    RDB_FIREHOSE: { dimensionName: 'RDB_QUERY_IDS' },
                    STORY_MESSAGE: { dimensionName: 'STORY' },
                    TWITTER: { dimensionName: 'TRENDING_TOPIC' },
                }),
            ],
            sorts: [
                new Sort({ order: 'DESC', projections: 0 }),
                new Sort({ order: 'ASC', groupBys: 0 }),
            ],
            timePeriods: [{ key: 'last_7_days' }, { previousPeriod: true }],
        }) as any,
    ],
    position: DefaultWidgetPosition,
    label: {
        titleText: 'Tree Map',
        size: WIDGET_LABEL_SIZE.primary,
        enabled: false,
    },
    options: {
        labelSize: 30,
        metricGroupOptions: {
            enabled: true,
            metric: {
                size: 35,
                enabled: true,
                format: {
                    decimals: 2,
                    useShortened: true,
                },
            },
            metricName: {
                size: 20,
                enabled: true,
            },
            percentChange: {
                size: 20,
                enabled: false,
            },
        },
    },
};
